import { DatasourceCanRoleIcon } from '@tableau/icons/DatasourceCanRoleIcon';
import { call } from 'redux-saga/effects';

import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { DataRoleCard } from '~src/dataRole/components/cardView/DataRoleCard';
import { DataRoles } from '~src/dataRole/resources/Dataroles';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ContentTypeFilterClause,MixedContentItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { DataRoleContentType } from '~src/spacesPlatform/models/ContentTypes';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { getDataRoleInfos } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { getGenericDefaultFilters } from '../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const DataRoleDefinition: MixedContentItemDefinition & SpaceDefinition<'dataRole'> = {
  itemType: 'dataRole',
  contentType: 'dataRole',
  singularName: Messages.dataRole,
  pluralName: Messages.dataRoles,
  emptyStateMessage: Messages.dataRolesEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Dataroles,
  contentFilterKeys: DataRoleContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: DataRoleCard,
  listViewIconType: DatasourceCanRoleIcon,
  filterClause: ServerFilterClauses.ContentType(['dataRole']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.dataRoleUrl(contentId),
  getBasicQuery: () => {
    return DataRoles.all().withExtraParams(DataRoleContentType.extraQueryParams);
  },
  fieldValueResourceType: 'dataRole',
  getContentInfo: (contentList: IContentInfo[]) => call(getDataRoleInfos, contentList),
  supportedDisplayModes: ['list', 'thumbnail'],
  headerIconPath: () => imgPath('spaces_masthead_datarole.svg'),
};
